import React from 'react';

// Helpers
import { copy } from '../constants';

// Styles
import styles from './styles/Error.scss';

const Error = () => {
    return (
        <div className={styles.error}>
            <div className={styles.privateError}>{copy.error.ERROR_HEADER}</div>
            <div className={styles.access}>
                {copy.error.ERROR_TEXT} <a href="/favorites/items/">your favorites</a>
            </div>
        </div>
    );
};

export default Error;
